module.exports = __webpack_public_path__ + "static/media/icon_theme_off.918d0d3a.png";